import { toast } from 'react-toastify';
import { Button } from "@mui/material";
import debounce from 'lodash/debounce';
import { useRecoilValue } from 'recoil';
import TextField from '@mui/material/TextField';
import React, { useState, useEffect } from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import { Employee, EmployeeApi } from '../../../../../api/clinic-management';
import { loginInfo, branchRoles, configState } from '../../../../../recoil/atoms';
import { ErrorMessage, FormikProps, FormikValues, getIn, useFormikContext } from 'formik';

export default function AutocompleteDoctor(props: any) {
  const { name } = props;
  const config = useRecoilValue(configState);
  const loggedInBranch = useRecoilValue(loginInfo);
  const availableRoles = useRecoilValue(branchRoles);
  const formik: FormikProps<FormikValues> = useFormikContext();  

  const [inputValue, setInputValue] = useState('');
  const [doctors, setDoctors] = useState<Employee[]>([]);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [resultCount, setResultCount] = useState<number | undefined>(1);

  const role = availableRoles?.find((item) => {
    return "Doctor" === item.Name;
  });

  const getDoctors = () => {
    const employee = new EmployeeApi(config);
    if (role) {
      employee
        .getEmployeesofTenant(loggedInBranch?.BranchID, loggedInBranch?.TenantID, role?.RoleID)
        .then((res) => {          
          setDoctors(res.data);
        })
        .catch((err) => {          
          toast.error(err?.response?.data?.detail);
        })
        .finally(() => {
          setIsLoading(false);
        });
    } else {
      toast.error("These doctors don't exist in this branch!");
      setIsLoading(false);
    }
  };

  const handleLoadMore = () => {
    setCurrentPage(prevPage => prevPage + 1);
  };

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    setInputValue(value);
  };
  
  useEffect(() => {
    const debouncedGetDoctors = debounce(getDoctors, 600);
    debouncedGetDoctors();
    return () => {
      debouncedGetDoctors.cancel();
    };
  }, [inputValue, currentPage]);

  return (
    <>
      <Autocomplete
        autoHighlight
        options={doctors}
        getOptionLabel={(option) =>
          option.User.FirstName.concat(' ', option.User.MiddleName, ' ', option.User.FamilyName)
        }
        sx={{ width: '100%' }}
        onChange={(event, value) => {
          formik.setFieldValue(name, value?.EmployeeID);
          if (props.setSelecteddoctorID) {
            props.setSelecteddoctorID(value?.EmployeeID);
          }
        }}
        loading={!isLoading}
        filterOptions={(options, state) => (options)}
        onInputChange={(e, newInputValue) => setInputValue(newInputValue)}
        isOptionEqualToValue={(option, value) => option?.EmployeeID === value?.EmployeeID}
        renderOption={(props, option) => (
          <div key={option.EmployeeID}>
            <li {...props}>
              <div>
                {option.User.FirstName} {option.User.MiddleName} {option.User.FamilyName}
              </div>
            </li>
            {option === doctors[doctors.length - 1] && 
              resultCount !== undefined && doctors.length < resultCount && (
                <li key="loadMore">
                  <Button onClick={handleLoadMore} disabled={isLoading} fullWidth>
                    Load More
                  </Button>
                </li>
            )}
          </div>
        )}
        renderInput={(params) => {
          return (
            <TextField
              {...params}
              label="Choose a doctor"
              id={name}
              name={name}
              helperText={<ErrorMessage name={name} />}
              error={!!(getIn(formik.touched, name) && getIn(formik.errors, name))}
              value={inputValue}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => handleSearchChange(event)}
            />
          );
        }}
      />
    </>
  );
}
